/**
 * ExtensionsCtrl controller
 * Show all Extensions
 */

import { PLAYBACK_TOKEN_GENERATOR_TYPES } from 'app/core/constants'
import { remove, replace } from 'app/helpers/entity'

// controller mixins
ExtensionsCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ExtensionsCtrl controller
 *
 * @class ExtensionsCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:ExtensionsCtrl
 */
/* @ngInject */
export default function ExtensionsCtrl (
  $scope,
  $uibModal,
  DeviceRedirects,
  Extension,
  PlaybackTokenGenerator,
  TemplateVariable
) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Playback token generators types
   *
   * @memberof mwApp/catchups.controller:ExtensionsCtrl
   * @type {Object}
   */
  vm.token_generators_types = angular.copy(PLAYBACK_TOKEN_GENERATOR_TYPES)
  delete vm.token_generators_types.AKAMAI_EDGIO

  vm.networksForTv = []
  /**
   * Extensions list
   *
   * @memberof mwApp/catchups.controller:ExtensionsCtrl
   * @name vm.extensions
   * @type {Object}
   */

  // get extensions
  Extension.load(undefined, {
    deviceRedirects: ['DeviceRedirects'],
    playbackTokenGenerators: ['PlaybackTokenGenerator'],
    variables: ['TemplateVariable']
  }).to(vm.extensions = {})
    .then(() => {
      vm.extensions.playbackTokenGenerators.forEach(ptg => {
        if (ptg.playbackTokenGeneratorType === 'AKAMAI_EDGIO') {
          ptg.playbackTokenGeneratorType = 'MULTI_CDN'
        }
      })

      for (const variable of vm.extensions.variables) {
        variable.organizations = []
        for (const override of variable.overrides) {
          const name = override?.target?.entityName
          if (!name || vm.networksForTv.includes(name)) continue
          vm.networksForTv.push(name)
          if (name || !variable.organizations.includes(name)) {
            variable.organizations.push(name)
          }
        }
      }
    })
    .then(() => { $scope.loading = false })

  /**
   * Delete extensions by type
   *
   * @memberof mwApp/settings.controller:ExtensionsCtrl
   */
  vm.delete = {
    playbackTokenGenerator: ptg =>
      ptg._delete()
        .then(remove(vm.extensions.playbackTokenGenerators)(ptg)),

    deviceRedirect: redirect =>
      redirect._delete()
        .then(remove(vm.extensions.deviceRedirects)(redirect)),

    templateVariable: tv =>
      tv._delete()
        .then(remove(vm.extensions.variables)(tv))
  }

  /**
   * Create/Edit extensions by type
   *
   * @memberof mwApp/settings.controller:ExtensionsCtrl
   */
  vm.add = vm.edit = {

    _modal (options) {
      return $uibModal.open(
        angular.extend({
          animation: false,
          size: 'lg'
        }, options)
      ).result
    },

    /**
     * Create/Edit playback token generator
     *
     * @memberof mwApp/settings.controller:ExtensionsCtrl
     * @param  {models.PlaybackTokenGenerator} ptg
     */
    playbackTokenGenerator (ptg) {
      this._modal({
        templateUrl: 'components/settings/views/addPlaybackTokenGenerator.html',
        controller: 'AddPlaybackTokenGeneratorCtrl as vm',
        resolve: {
          ptg: ptg
            ? PlaybackTokenGenerator.load({ id: ptg.id })
            : new PlaybackTokenGenerator()
        }
      }).then(replace(vm.extensions.playbackTokenGenerators)(false))
    },

    /**
     * Create/Edit device redirect
     *
     * @memberof mwApp/settings.controller:ExtensionsCtrl
     * @param  {models.Extension} redirect
     */
    deviceRedirect (redirect) {
      this._modal({
        templateUrl: 'components/settings/views/addDeviceRedirect.html',
        controller: 'AddDeviceRedirectCtrl as vm',
        resolve: {
          redirect: redirect
            ? DeviceRedirects.load({ id: redirect.id })
            : new DeviceRedirects()
        }
      }).then(replace(vm.extensions.deviceRedirects)(false))
    },

    /**
     * Create/Edit TemplateVariable
     *
     * @memberof mwApp/settings.controller:AddTemplateVariableCtrl
     * @param  {models.TemplateVariable} tv
     */
    templateVariable (tv) {
      this._modal({
        templateUrl: 'components/settings/views/addTemplateVariable.html',
        controller: 'AddTemplateVariableCtrl as vm',
        resolve: {
          templateVariable: tv
            ? TemplateVariable.load({ id: tv.id })
            : new TemplateVariable(),
          variables: function () {
            return vm.extensions.variables
          }

        }
      }).then(replace(vm.extensions.variables)(false))
    }
  }

  /**
   * Images for different extension types
   *
   * @memberof mwApp/catchups.controller:ExtensionsCtrl
   * @type {Object}
   */
  vm.images = {
    AKAMAI: require('./img/Akamai.svg'),
    AKAMAI_EDGIO: require('./img/Akamai.svg'),
    LEVEL3: require('./img/Level3.svg'),
    WOWZA: require('./img/Wowza.png'),
    CDN77: require('./img/CDN77.svg'),
    FLUSSONIC: require('./img/Flussonic.png'),
    NIMBLE: require('./img/Nimble.png'),
    ONAPP: require('./img/OnApp.png'),
    CLOUDFRONT: require('./img/CloudFront.svg')
  }

  vm.ptgTypeWithoutIcons = {
    STREAMPOOL: 'Streampool',
    CACHEFLY: 'CacheFly',
    MULTI_CDN: 'Multi CDN'
  }

  vm.keys = function (obj) {
    return Object.keys(obj)
  }

  $scope.getters = {
    caseInsensitiveName: function (obj) {
      return obj.name.toLowerCase()
    }
  }
}
